import { render, staticRenderFns } from "./summary-airport.vue?vue&type=template&id=119e988a&scoped=true"
import script from "./summary-airport.vue?vue&type=script&lang=ts&setup=true"
export * from "./summary-airport.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./summary-airport.vue?vue&type=style&index=0&id=119e988a&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119e988a",
  null
  
)

export default component.exports